
import { gql } from '@apollo/client';

// NOTE: we call them classes in the front end after a change but the backend and databse still use the term courses

export const GET_CLASSES = gql`
query Classes($search: String, $filters: String) {
  classes(search: $search, filters: $filters) {
    id
    name
    SKU
    program
    classLabel
    participants {
        id
    }
    classRecords {
        id
        user {
            id
            name
            identifier
            photoUrl
        }
        connectionScore
        contributionScore
        endCapacityScore
        startCapacityScore
        confidenceScore
        completionStatus
        attendanceScore
        teacherComment
        notes
    }
    level
    timesOfWeek
    teachers {
        id
        name
    }
    courseParticipantCount
  }
}`;
